import { CSSProperties } from 'react'
import styled from '@emotion/styled'
import { useAtom, useAtomValue } from 'jotai'
import { Drawer } from 'vaul'
import { useRouterState, useRouter } from '@tanstack/react-router'

import { Flex } from '../Flex'

import MobileSidebarContent from './MobileSidebarContent'
import MobileSidebarHeader from './MobileSidebarHeader'

import { MenuButton } from '@/assets/icons'
import { colors } from '@/constants'
import {
  sidebarConfigPathAtom,
  sidebarLocationPathAtom,
  sidebarOpenAtom,
} from '@/store/sidebar'
import { store } from '@/store/store'
import { findChild } from '@/utils/subMenu'

const overlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  backgroundColor: '#00000060',
}

const InnerContentWrapper = styled(Flex)`
  background-color: ${colors.darkBlue1};
  width: 100%;
  height: 100%;
  flex-grow: 1;
  flex-direction: column;
  padding: 15px 15px 30px 15px;
  gap: 2.5rem;
`

const contentStyle = {
  '--initial-transform': '100%',
  right: 0,
  position: 'fixed',
  zIndex: 1000,
  outline: 'none',
  display: 'flex',
  width: '100%',
  height: '100%',
} as CSSProperties

export default function VaulDrawer({
  icon = <MenuButton />,
}: {
  icon?: JSX.Element
}) {
  const location = useRouterState({ select: (s) => s.location.pathname })
  const router = useRouter()
  const [open, setOpen] = useAtom(sidebarOpenAtom)
  const currentLocation = useAtomValue(sidebarLocationPathAtom)
  const config = useAtomValue(sidebarConfigPathAtom)
  const route = findChild(currentLocation, config)

  return (
    <Drawer.Root
      direction="right"
      open={open}
      onOpenChange={(state) => {
        if (state) store.set(sidebarLocationPathAtom, location)
        setOpen(state)
      }}
      noBodyStyles
    >
      <Drawer.Trigger style={{ zIndex: 1001 }}>{icon}</Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay style={overlayStyle} />
        <Drawer.Content style={contentStyle}>
          <Drawer.Title style={{ display: 'none' }}>
            Mobile Sidebar
          </Drawer.Title>
          <Drawer.Description style={{ display: 'none' }}>
            Mobile Sidebar
          </Drawer.Description>
          <InnerContentWrapper>
            <MobileSidebarHeader route={route} onClose={() => setOpen(false)} />
            <MobileSidebarContent
              isSubMenu={!!route?.submenu}
              onClick={() => {
                const path = store.get(sidebarLocationPathAtom)
                router.navigate({ to: path })
                setOpen(false)
              }}
            />
          </InnerContentWrapper>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
